import * as React from 'react';
import { ReactElement, useState } from 'react';
import { Breadcrumbs, HiddenPriorityTitle, Message } from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import routes from '../../routing/routes';
import Layout from '../Layout';
import AktualitaList from '../../module/Aktuality/List/AktualitaList';
import useAktualitaList from './hook/useAktualitaList';

const AktualitaListPage = (): ReactElement => {
  const {
    aktualitaPage,
    pageNumberFromUrl,
    status,
  } = useAktualitaList();
  const [displayError, setDisplayError] = useState(true);

  return (
    <Layout>
      <HiddenPriorityTitle>Aktuality</HiddenPriorityTitle>
      <Breadcrumbs
        routeList={[
          {
            to: routes.home.to,
            heading: routes.home.name,
          },
          {
            to: routes.aktuality.to,
            heading: routes.aktuality.name,
          }]}
      />
      <Loader loading={status.loading}>
        {(status.responseCode && status.responseCode > 399)
          ? (
            <>
              {displayError && (
                <Message
                  type="error"
                  onClear={() => setDisplayError(false)}
                  headingSize="m"
                >
                  Nepodarilo sa načítať aktuality.
                </Message>
              )}
            </>
          )
          : (
            <AktualitaList
              aktualitaPage={aktualitaPage}
              pageNumberFromUrl={pageNumberFromUrl}
            />
          )}
      </Loader>
    </Layout>
  );
};

export default AktualitaListPage;
